import React, { useState, useEffect, useMemo } from "react";

const LandingPageGenerator = () => {
  const [formData, setFormData] = useState({
    // Basic Info
    websiteName: "MyWebsite.com",
    businessType: "properti",
    logoIcon: "🏠",

    // Colors
    primaryColor: "#38a169",
    secondaryColor: "#2f855a",
    darkColor: "#22543d",
    colorTheme: "custom",

    // Hero Content
    heroTitle: "Solusi Terbaik Untuk Kebutuhan Anda",
    heroSubtitle:
      "Temukan layanan berkualitas dengan lokasi strategis dan fasilitas lengkap",
    ctaText: "Hubungi Kami",

    // Section Heights
    heroHeight: "100vh",
    summaryHeight: "100vh",
    galleryHeight: "100vh",
    contactHeight: "100vh",

    // Summary
    summaryTitle: "Layanan Berkualitas Terpercaya",
    summaryText1:
      "Kami menyediakan solusi terbaik dengan standar kualitas tinggi dan pelayanan yang memuaskan.",
    summaryText2:
      "Dengan pengalaman bertahun-tahun, kami berkomitmen memberikan yang terbaik untuk kebutuhan Anda.",

    // Features Configuration
    featuresCount: 2,

    // Features (up to 8 features)
    feature1Icon: "🔒",
    feature1Title: "Terpercaya",
    feature1Desc: "Layanan terpercaya & berkualitas",

    feature2Icon: "📍",
    feature2Title: "Lokasi Strategis",
    feature2Desc: "Mudah diakses & strategis",

    feature3Icon: "⭐",
    feature3Title: "Kualitas Terbaik",
    feature3Desc: "Standar kualitas tinggi",

    feature4Icon: "💰",
    feature4Title: "Harga Terjangkau",
    feature4Desc: "Sesuai budget Anda",

    feature5Icon: "🚀",
    feature5Title: "Pelayanan Cepat",
    feature5Desc: "Respon time yang singkat",

    feature6Icon: "🛡️",
    feature6Title: "Garansi Aman",
    feature6Desc: "Jaminan keamanan terpercaya",

    feature7Icon: "💎",
    feature7Title: "Premium Quality",
    feature7Desc: "Kualitas premium terjamin",

    feature8Icon: "🎯",
    feature8Title: "Tepat Sasaran",
    feature8Desc: "Solusi yang tepat sasaran",

    // Gallery Configuration
    productsCount: 1,
    galleryCount: 3,
    galleryTitle: "Pilihan Tersedia",
    gallerySubtitle:
      "Beragam paket yang telah dirancang khusus untuk memenuhi berbagai kebutuhan Anda dengan kualitas terbaik dan harga yang kompetitif.",
    galleryStyle: "carousel", // 'grid' or 'carousel'
    carouselAutoplay: true,
    carouselSpeed: 3, // seconds
    carouselNavStyle: "arrows", // 'dots', 'arrows', 'thumbnails'
    carouselTransition: "slide", // 'slide', 'fade', 'zoom'

    // Gallery Items (up to 12 items)
    gallery1Title: "Paket Premium",
    gallery1Desc: "Solusi lengkap dengan fasilitas terbaik",
    gallery1Image: "",

    gallery2Title: "Paket Standar",
    gallery2Desc: "Pilihan terbaik dengan harga terjangkau",
    gallery2Image: "",

    gallery3Title: "Paket Ekonomis",
    gallery3Desc: "Solusi hemat tanpa mengurangi kualitas",
    gallery3Image: "",

    gallery4Title: "Paket Khusus",
    gallery4Desc: "Customized sesuai kebutuhan spesifik",
    gallery4Image: "",

    gallery5Title: "Paket Keluarga",
    gallery5Desc: "Cocok untuk kebutuhan keluarga",
    gallery5Image: "",

    gallery6Title: "Paket Bisnis",
    gallery6Desc: "Solusi untuk keperluan bisnis",
    gallery6Image: "",

    gallery7Title: "Paket Enterprise",
    gallery7Desc: "Solusi untuk perusahaan besar",
    gallery7Image: "",

    gallery8Title: "Paket Startup",
    gallery8Desc: "Cocok untuk startup dan UMKM",
    gallery8Image: "",

    gallery9Title: "Paket Personal",
    gallery9Desc: "Untuk kebutuhan personal",
    gallery9Image: "",

    gallery10Title: "Paket Professional",
    gallery10Desc: "Untuk professional dan freelancer",
    gallery10Image: "",

    gallery11Title: "Paket Custom",
    gallery11Desc: "Disesuaikan dengan kebutuhan unik",
    gallery11Image: "",

    gallery12Title: "Paket Unlimited",
    gallery12Desc: "Tanpa batas untuk kebutuhan maksimal",
    gallery12Image: "",

    // Products Configuration
    product1Title: "Produk 1",
    product1Description: "Deskripsi produk pertama yang menarik",
    product1Photo1: "",
    product1Photo2: "",
    product1Photo3: "",

    product2Title: "Produk 2",
    product2Description: "Deskripsi produk kedua yang berkualitas",
    product2Photo1: "",
    product2Photo2: "",
    product2Photo3: "",

    product3Title: "Produk 3",
    product3Description: "Deskripsi produk ketiga yang unggul",
    product3Photo1: "",
    product3Photo2: "",
    product3Photo3: "",

    product4Title: "Produk 4",
    product4Description: "Deskripsi produk keempat yang inovatif",
    product4Photo1: "",
    product4Photo2: "",
    product4Photo3: "",

    product5Title: "Produk 5",
    product5Description: "Deskripsi produk kelima yang modern",
    product5Photo1: "",
    product5Photo2: "",
    product5Photo3: "",

    product6Title: "Produk 6",
    product6Description: "Deskripsi produk keenam yang revolusioner",
    product6Photo1: "",
    product6Photo2: "",
    product6Photo3: "",

    // WhatsApp Integration
    whatsappNumber: "6281234567890",
    whatsappText: "Halo, saya tertarik dengan layanan Anda",
    email: "info@mywebsite.com",

    // Header Settings
    headerEnabled: false,
    headerFloating: false,

    // Scrolling Settings
    scrollingType: "smooth", // 'smooth' or 'section'

    // GTM Settings
    gtmContainerId: "",
    gtmEnabled: true,
  });

  const [generatedHTML, setGeneratedHTML] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState("iphone-15");
  const [isLandscape, setIsLandscape] = useState(false);
  const [deviceCategory, setDeviceCategory] = useState("mobile");
  const [regionalPreset, setRegionalPreset] = useState("global");

  const heightOptions = [
    {
      value: "80vh",
      label: "80vh - Compact",
      mobile: "Good for quick reading",
    },
    {
      value: "100vh",
      label: "100vh - Full Screen",
      mobile: "Perfect mobile experience",
    },
    {
      value: "120vh",
      label: "120vh - Extended",
      mobile: "May need scrolling on mobile",
    },
  ];

  const getHeightWarning = (height) => {
    switch (height) {
      case "80vh":
        return {
          type: "success",
          text: "Mobile-friendly: Content fits in one view",
        };
      case "100vh":
        return { type: "info", text: "Perfect: Full-screen mobile experience" };
      case "120vh":
        return {
          type: "warning",
          text: "Caution: Users may need to scroll on mobile",
        };
      default:
        return { type: "info", text: "Standard height" };
    }
  };

  const getScrollIndicator = (height) => {
    switch (height) {
      case "80vh":
        return "📱 1 swipe down";
      case "100vh":
        return "📱 1 full swipe";
      case "120vh":
        return "📱 1.2 swipes (scroll within)";
      default:
        return "📱 1 swipe";
    }
  };

  const devicePresets = useMemo(
    () => ({
      desktop: {
        width: "100%",
        height: "500px",
        name: "Desktop",
        category: "desktop",
      },

      // ANDROID DEVICES (2025 Updated)
      "standard-android": {
        width: 360,
        height: 800,
        name: "Standard Android",
        category: "mobile",
        share: "11.7%",
        icon: "🤖",
      },
      "galaxy-s24-ultra": {
        width: 384,
        height: 854,
        name: "Samsung Galaxy S24 Ultra",
        category: "mobile",
        share: "15.2%",
        icon: "🤖",
      },
      "pixel-8-pro": {
        width: 393,
        height: 851,
        name: "Google Pixel 8 Pro",
        category: "mobile",
        share: "8.3%",
        icon: "🤖",
      },
      "xiaomi-flagship": {
        width: 393,
        height: 873,
        name: "Xiaomi Flagship",
        category: "mobile",
        share: "6.1%",
        icon: "🤖",
      },

      // IPHONE DEVICES (Current Models)
      "iphone-15": {
        width: 393,
        height: 852,
        name: "iPhone 15",
        category: "mobile",
        share: "18.4%",
        icon: "📱",
      },
      "iphone-15-pro-max": {
        width: 430,
        height: 932,
        name: "iPhone 15 Pro Max",
        category: "mobile",
        share: "12.1%",
        icon: "📱",
      },
      "iphone-14": {
        width: 390,
        height: 844,
        name: "iPhone 14",
        category: "mobile",
        share: "9.2%",
        icon: "📱",
      },
      "iphone-se": {
        width: 375,
        height: 667,
        name: "iPhone SE (Budget)",
        category: "mobile",
        share: "7.8%",
        icon: "📱",
      },

      // IPAD DEVICES
      "ipad-10th": {
        width: 820,
        height: 1180,
        widthLandscape: 1180,
        heightLandscape: 820,
        name: "iPad (10th gen)",
        category: "tablet",
        icon: "📱",
      },
      "ipad-air": {
        width: 834,
        height: 1194,
        widthLandscape: 1194,
        heightLandscape: 834,
        name: "iPad Air",
        category: "tablet",
        icon: "📱",
      },
      "ipad-pro-11": {
        width: 834,
        height: 1194,
        widthLandscape: 1194,
        heightLandscape: 834,
        name: 'iPad Pro 11"',
        category: "tablet",
        icon: "📱",
      },
      "ipad-pro-12": {
        width: 1024,
        height: 1366,
        widthLandscape: 1366,
        heightLandscape: 1024,
        name: 'iPad Pro 12.9"',
        category: "tablet",
        icon: "📱",
      },

      // ANDROID TABLETS
      "galaxy-tab-s9": {
        width: 800,
        height: 1280,
        widthLandscape: 1280,
        heightLandscape: 800,
        name: "Samsung Galaxy Tab S9",
        category: "tablet",
        icon: "🤖",
      },
      "android-tablet": {
        width: 768,
        height: 1024,
        widthLandscape: 1024,
        heightLandscape: 768,
        name: "Standard Android Tablet",
        category: "tablet",
        icon: "🤖",
      },
      "large-android-tablet": {
        width: 800,
        height: 1280,
        widthLandscape: 1280,
        heightLandscape: 800,
        name: "Large Android Tablet",
        category: "tablet",
        icon: "🤖",
      },
    }),
    []
  );

  const regionalPresets = {
    global: {
      name: "🌍 Global Focus",
      devices: [
        "iphone-15",
        "galaxy-s24-ultra",
        "standard-android",
        "iphone-15-pro-max",
        "pixel-8-pro",
        "iphone-14",
      ],
      description: "Balanced iOS/Android split",
    },
    asia: {
      name: "🌏 Asia Focus",
      devices: [
        "xiaomi-flagship",
        "galaxy-s24-ultra",
        "standard-android",
        "pixel-8-pro",
        "iphone-15",
        "galaxy-tab-s9",
      ],
      description: "Emphasize Xiaomi, Samsung, Android devices",
    },
    us: {
      name: "🇺🇸 US Focus",
      devices: [
        "iphone-15",
        "iphone-15-pro-max",
        "iphone-14",
        "iphone-se",
        "galaxy-s24-ultra",
        "pixel-8-pro",
      ],
      description: "Emphasize iPhone variants",
    },
  };

  const getDeviceStyle = () => {
    if (selectedDevice === "desktop") {
      return { width: "100%", height: "500px" };
    }

    const device = devicePresets[selectedDevice];
    if (!device) return { width: "100%", height: "500px" };

    let width, height;

    if (isLandscape && device.widthLandscape && device.heightLandscape) {
      // Use dedicated landscape dimensions for tablets
      width = device.widthLandscape;
      height = device.heightLandscape;
    } else if (isLandscape) {
      // Swap dimensions for phones
      width = device.height;
      height = device.width;
    } else {
      // Portrait mode (default)
      width = device.width;
      height = device.height;
    }

    return {
      width: `${width}px`,
      height: `${height}px`,
      maxWidth: "100%",
      margin: "0 auto",
      transition: "all 0.3s ease",
    };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyPress = (e) => {
      // Ignore if user is typing in input fields
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
        return;

      const deviceKeys = {
        1: "iphone-15",
        2: "galaxy-s24-ultra",
        3: "standard-android",
        4: "iphone-15-pro-max",
        5: "pixel-8-pro",
        6: "xiaomi-flagship",
        7: "iphone-14",
        8: "iphone-se",
        9: "desktop",
      };

      if (deviceKeys[e.key]) {
        setSelectedDevice(deviceKeys[e.key]);
        if (deviceKeys[e.key] !== "desktop") {
          const device = devicePresets[deviceKeys[e.key]];
          if (device.category === "mobile") setDeviceCategory("mobile");
          else if (device.category === "tablet") setDeviceCategory("tablet");
        } else {
          setDeviceCategory("desktop");
        }
      }

      // Orientation rotation with 'R' key
      if (e.key.toLowerCase() === "r" && selectedDevice !== "desktop") {
        setIsLandscape(!isLandscape);
      }

      // Fullscreen toggle with 'F' key
      if (e.key.toLowerCase() === "f") {
        toggleFullscreen();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [selectedDevice, isLandscape, devicePresets]);

  // Utility functions
  const toggleFullscreen = () => {
    const previewElement = document.getElementById("device-preview");
    if (!document.fullscreenElement) {
      previewElement?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  const colorThemes = {
    custom: {
      name: "Custom",
      primaryColor: formData.primaryColor,
      secondaryColor: formData.secondaryColor,
      darkColor: formData.darkColor,
    },
    lightBlue: {
      name: "Biru Muda Gradasi",
      primaryColor: "#7dd3fc",
      secondaryColor: "#0ea5e9",
      darkColor: "#075985",
    },
    navy: {
      name: "Navy Professional",
      primaryColor: "#1e40af",
      secondaryColor: "#1e3a8a",
      darkColor: "#1e293b",
    },
    red: {
      name: "Merah Dinamis",
      primaryColor: "#ef4444",
      secondaryColor: "#dc2626",
      darkColor: "#991b1b",
    },
    emerald: {
      name: "Hijau Emerald",
      primaryColor: "#10b981",
      secondaryColor: "#059669",
      darkColor: "#064e3b",
    },
    purple: {
      name: "Ungu Modern",
      primaryColor: "#8b5cf6",
      secondaryColor: "#7c3aed",
      darkColor: "#4c1d95",
    },
    orange: {
      name: "Orange Energik",
      primaryColor: "#f97316",
      secondaryColor: "#ea580c",
      darkColor: "#9a3412",
    },
  };

  const applyColorTheme = (themeKey) => {
    const theme = colorThemes[themeKey];
    if (theme) {
      setFormData((prev) => ({
        ...prev,
        colorTheme: themeKey,
        primaryColor: theme.primaryColor,
        secondaryColor: theme.secondaryColor,
        darkColor: theme.darkColor,
      }));
    }
  };

  const handleImageUpload = (e, imageName) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
      ];
      if (!validTypes.includes(file.type)) {
        alert("Please upload a valid image file (JPEG, PNG, GIF, or WebP)");
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert("File size should be less than 5MB");
        return;
      }

      // Create FileReader to convert to base64
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData((prev) => ({
          ...prev,
          [imageName]: event.target.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (imageName) => {
    setFormData((prev) => ({
      ...prev,
      [imageName]: "",
    }));
  };

  const generateHTML = () => {
    const html = `<!DOCTYPE html>
<html lang="id">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${formData.websiteName} - ${formData.heroTitle}</title>
    <meta name="description" content="${formData.heroSubtitle}">
    <meta name="robots" content="noindex, nofollow">
    <meta name="author" content="${formData.websiteName}">
    <meta property="og:title" content="${formData.websiteName} - ${
      formData.heroTitle
    }">
    <meta property="og:description" content="${formData.heroSubtitle}">
    <meta property="og:type" content="website">
    <!-- Conversion-optimized for Google Ads landing pages -->
    <meta name="google-ads-landing-page" content="true">
    ${
      formData.gtmEnabled && formData.gtmContainerId
        ? `
    <!-- Google Tag Manager -->
    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${formData.gtmContainerId}');</script>
    <!-- End Google Tag Manager -->
    `
        : ""
    }
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #2d3748;
            overflow-x: hidden;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        /* Header */
        header {
            background: linear-gradient(135deg, ${formData.primaryColor} 0%, ${
      formData.secondaryColor
    } 100%);
            color: white;
            padding: 1rem 0;
            ${
              formData.headerFloating
                ? "position: fixed;"
                : "position: relative;"
            }
            width: 100%;
            top: 0;
            z-index: 1000;
            ${
              formData.headerFloating
                ? "box-shadow: 0 2px 10px rgba(0,0,0,0.1);"
                : ""
            }
        }

        nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .logo {
            font-size: 1.5rem;
            font-weight: bold;
        }

        .nav-links {
            display: flex;
            list-style: none;
        }

        .nav-links a {
            color: white;
            text-decoration: none;
            padding: 10px 20px;
            border-radius: 25px;
            background: rgba(255,255,255,0.1);
            transition: all 0.3s;
        }

        .nav-links a:hover {
            background: rgba(255,255,255,0.2);
        }

        /* Hero Section */
        .hero {
            background: linear-gradient(135deg, ${formData.primaryColor} 0%, ${
      formData.secondaryColor
    } 100%);
            color: white;
            min-height: ${formData.heroHeight};
            display: flex;
            align-items: center;
            text-align: center;
            position: relative;
            overflow: hidden;
            padding-top: ${
              formData.headerEnabled && formData.headerFloating
                ? "80px"
                : "20px"
            };
            padding-bottom: 20px;
        }

        .hero::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><polygon fill="rgba(255,255,255,0.08)" points="0,1000 1000,700 1000,1000"/></svg>');
            background-size: cover;
        }

        .hero-content {
            position: relative;
            z-index: 2;
        }

        .hero h1 {
            font-size: 2.8rem;
            margin-bottom: 1rem;
            animation: fadeInUp 1s ease-out;
        }

        .hero p {
            font-size: 1.2rem;
            margin-bottom: 2rem;
            opacity: 0.95;
            animation: fadeInUp 1s ease-out 0.2s both;
            max-width: 600px;
            margin-left: auto;
            margin-right: auto;
        }

        .cta-button {
            background: ${formData.darkColor};
            color: white;
            padding: 12px 30px;
            border: none;
            border-radius: 25px;
            font-size: 1rem;
            cursor: pointer;
            transition: all 0.3s;
            text-decoration: none;
            display: inline-block;
            animation: fadeInUp 1s ease-out 0.4s both;
        }

        .cta-button:hover {
            background: #1a202c;
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.3);
        }

        /* Summary Section */
        .summary {
            min-height: ${formData.summaryHeight};
            display: flex;
            align-items: center;
            padding: 50px 0;
            background: #f7fafc;
        }

        .summary-content {
            text-align: center;
            max-width: 800px;
            margin: 0 auto;
        }

        .summary h2 {
            font-size: clamp(1.8rem, 5vw, 2.4rem);
            margin-bottom: 1.5rem;
            color: ${formData.secondaryColor};
            font-weight: 700;
            letter-spacing: -0.02em;
            line-height: 1.2;
        }

        .summary p {
            font-size: clamp(1rem, 3.5vw, 1.2rem);
            color: #4a5568;
            margin-bottom: 1.5rem;
            line-height: 1.6;
            font-weight: 400;
        }

        .features-highlight {
            display: grid;
            gap: 1.5rem;
            margin-top: 2rem;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        }

        /* Responsive grid based on features count */
        .features-highlight.features-1 {
            grid-template-columns: 1fr;
            max-width: 400px;
            margin-left: auto;
            margin-right: auto;
        }
        
        .features-highlight.features-2 {
            grid-template-columns: repeat(2, 1fr);
            max-width: 800px;
            margin-left: auto;
            margin-right: auto;
        }
        
        .features-highlight.features-3 {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        }
        
        .features-highlight.features-4 {
            grid-template-columns: repeat(2, 1fr);
        }
        
        .features-highlight.features-5,
        .features-highlight.features-6 {
            grid-template-columns: repeat(3, 1fr);
        }
        
        .features-highlight.features-7,
        .features-highlight.features-8 {
            grid-template-columns: repeat(4, 1fr);
        }

        .feature-item {
            background: white;
            padding: 1.5rem;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.08);
            transition: transform 0.3s;
        }

        .feature-item:hover {
            transform: translateY(-3px);
        }

        .feature-icon {
            font-size: 2rem;
            margin-bottom: 0.5rem;
        }

        .feature-item h3 {
            font-size: 1rem;
            color: ${formData.secondaryColor};
            margin-bottom: 0.5rem;
        }

        .feature-item p {
            font-size: 0.9rem;
            color: #718096;
        }

        /* Gallery Section */
        .gallery {
            min-height: ${formData.galleryHeight};
            display: flex;
            align-items: center;
            padding: 50px 0;
        }

        /* Section Title Consistency */
        .section-title {
            text-align: center;
            font-size: clamp(1.8rem, 5vw, 2.4rem);
            margin-bottom: 1rem;
            color: ${formData.secondaryColor};
            font-weight: 700;
            letter-spacing: -0.02em;
            line-height: 1.2;
        }

        .section-subtitle {
            text-align: center;
            font-size: clamp(1rem, 3.5vw, 1.2rem);
            color: #4a5568;
            margin-bottom: 2rem;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
            line-height: 1.6;
            font-weight: 400;
        }

        .additional-benefit {
            background: #f7fafc;
            padding: 3rem 0;
            margin: 2rem 0;
        }

        .additional-benefit .section-title {
            margin-bottom: 1rem;
        }

        .additional-benefit .section-subtitle {
            margin-bottom: 0;
        }

        /* Products Section Styling */
        .products-container {
            display: grid;
            gap: 1.5rem;
            margin-top: 1.5rem;
        }

        .product-section {
            background: white;
            border-radius: 15px;
            padding: 1.5rem;
            box-shadow: 0 6px 20px rgba(0,0,0,0.08);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .product-section:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        }

        .product-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: ${formData.secondaryColor};
            margin-bottom: 0.75rem;
            text-align: center;
        }

        .product-description {
            font-size: 0.95rem;
            color: #4a5568;
            line-height: 1.5;
            text-align: center;
            margin-bottom: 1rem;
            max-width: 600px;
            margin-left: auto;
            margin-right: auto;
        }

        .product-photos {
            margin-top: 1rem;
        }

        .product-carousel {
            position: relative;
            width: 100%;
            max-width: 400px;
            margin: 0 auto;
        }

        .carousel-container {
            position: relative;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }

        .carousel-track {
            position: relative;
            width: 100%;
            height: 250px;
            overflow: hidden;
        }

        .carousel-slide {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transform: translateX(100%);
            transition: all 0.6s cubic-bezier(0.25, 0.1, 0.25, 1);
            cursor: pointer;
        }

        .carousel-slide.active {
            opacity: 1;
            transform: translateX(0);
        }

        .carousel-slide.prev {
            transform: translateX(-100%);
        }

        .carousel-slide.next {
            transform: translateX(100%);
        }

        .carousel-slide img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .photo-info {
            margin-top: 1rem;
            min-height: 30px;
        }

        .photo-details {
            display: none;
            text-align: center;
            transition: all 0.3s ease;
        }

        .photo-details.active {
            display: block;
        }

        .photo-title {
            font-size: 0.95rem;
            font-weight: 700;
            margin: 0 0 0.25rem 0;
            line-height: 1.3;
            color: #000000;
        }

        .photo-description {
            font-size: 0.85rem;
            margin: 0;
            opacity: 0.7;
            line-height: 1.4;
            color: #6b7280;
        }

        .carousel-btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(0,0,0,0.5);
            color: white;
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background 0.3s ease;
            z-index: 10;
        }

        .carousel-btn:hover {
            background: rgba(0,0,0,0.7);
        }

        .prev-btn {
            left: 10px;
        }

        .next-btn {
            right: 10px;
        }

        .carousel-indicators {
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 8px;
            z-index: 10;
        }

        .indicator {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 2px solid white;
            background: rgba(255,255,255,0.5);
            cursor: pointer;
            transition: background 0.3s ease;
        }

        .indicator.active {
            background: white;
        }

        .product-photo {
            width: 100%;
            max-width: 300px;
            height: 250px;
            border-radius: 12px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.3s ease;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }

        .product-photo:hover {
            transform: scale(1.05);
        }

        .product-photo img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .emoji-fallback {
            background: linear-gradient(45deg, ${formData.primaryColor}, ${
      formData.secondaryColor
    });
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            color: white;
        }

        .emoji-display {
            font-size: 3rem;
            margin-bottom: 0.5rem;
        }

        .photo-placeholder {
            font-size: 0.9rem;
            text-align: center;
            opacity: 0.9;
        }

        /* Mobile optimization for products */
        @media (max-width: 768px) {
            .products-container {
                gap: 1rem;
                margin-top: 1rem;
            }
            
            .product-section {
                padding: 1rem;
            }
            
            .product-carousel {
                max-width: 100%;
            }
            
            .carousel-track {
                height: 200px;
            }
            
            .carousel-btn {
                width: 35px;
                height: 35px;
            }
            
            .prev-btn {
                left: 5px;
            }
            
            .next-btn {
                right: 5px;
            }
            
            .product-photo {
                max-width: 100%;
                height: 200px;
            }
            
            .product-title {
                font-size: 1.1rem;
                margin-bottom: 0.5rem;
            }
            
            .product-description {
                font-size: 0.9rem;
                margin-bottom: 0.75rem;
            }
            
            .photo-info {
                margin-top: 0.75rem;
                min-height: 25px;
            }
            
            .photo-title {
                font-size: 0.85rem;
                font-weight: 700;
                color: #000000;
                margin-bottom: 0.2rem;
            }
            
            .photo-description {
                font-size: 0.75rem;
            }
        }

        .gallery-subtitle {
            text-align: center;
            font-size: clamp(1rem, 3.5vw, 1.2rem);
            color: #4a5568;
            margin-bottom: 2rem;
            max-width: 600px;
            margin-left: auto;
            margin-right: auto;
            line-height: 1.6;
            font-weight: 400;
        }

        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 1.5rem;
        }

        .gallery-item {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 6px 20px rgba(0,0,0,0.1);
            transition: transform 0.3s;
            cursor: pointer;
            position: relative;
        }

        .gallery-item:hover {
            transform: translateY(-5px);
        }

        .gallery-image {
            height: 300px;
            background: linear-gradient(45deg, ${formData.primaryColor}, ${
      formData.secondaryColor
    });
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 4rem;
        }

        .gallery-info {
            padding: 1.2rem;
            text-align: center;
        }

        .gallery-info h3 {
            font-size: 1.1rem;
            margin-bottom: 0.5rem;
            color: #2d3748;
        }

        .gallery-info p {
            color: #718096;
            font-size: 0.9rem;
        }

        /* Carousel Styles */
        .gallery-carousel {
            position: relative;
            max-width: 100%;
            margin: 0 auto;
        }

        .carousel-container {
            position: relative;
            overflow: hidden;
            border-radius: 12px;
            box-shadow: 0 6px 20px rgba(0,0,0,0.1);
        }

        .carousel-track {
            display: flex;
            position: relative;
            width: 100%;
        }

        .carousel-slide {
            min-width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            opacity: 0;
            transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
            transform: translateX(100%);
        }

        .carousel-slide.active {
            opacity: 1;
            transform: translateX(0);
            position: relative;
        }

        .carousel-slide.fade-transition {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        .carousel-slide.zoom-transition .gallery-item {
            transform: scale(0.8);
            transition: transform 0.5s ease-in-out;
        }

        .carousel-slide.active.zoom-transition .gallery-item {
            transform: scale(1);
        }

        .carousel-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255,255,255,0.9);
            border: none;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            z-index: 10;
            color: #2d3748;
        }

        .carousel-nav:hover {
            background: white;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .carousel-nav.prev {
            left: 20px;
        }

        .carousel-nav.next {
            right: 20px;
        }

        .carousel-dots {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 20px;
        }

        .carousel-dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 2px solid ${formData.primaryColor};
            background: transparent;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .carousel-dot.active,
        .carousel-dot:hover {
            background: ${formData.primaryColor};
        }

        .carousel-thumbnails {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 20px;
            flex-wrap: wrap;
        }

        .carousel-thumbnail {
            width: 80px;
            height: 60px;
            border: 2px solid transparent;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s ease;
            background: white;
            display: flex;
            flex-direction: column;
        }

        .carousel-thumbnail.active {
            border-color: ${formData.primaryColor};
            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        }

        .carousel-thumbnail:hover {
            transform: scale(1.05);
        }

        .thumbnail-image {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(45deg, ${formData.primaryColor}, ${
      formData.secondaryColor
    });
            color: white;
        }

        .thumbnail-title {
            font-size: 0.65rem;
            padding: 2px 4px;
            text-align: center;
            color: #2d3748;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .emoji-fallback,
        .emoji-fallback-thumb {
            font-size: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .emoji-fallback-thumb {
            font-size: 1.2rem;
        }

        /* Mobile Carousel Optimizations */
        @media (max-width: 768px) {
            .carousel-nav {
                width: 40px;
                height: 40px;
            }

            .carousel-nav.prev {
                left: 10px;
            }

            .carousel-nav.next {
                right: 10px;
            }

            .carousel-thumbnails {
                gap: 8px;
            }

            .carousel-thumbnail {
                width: 60px;
                height: 45px;
            }

            .thumbnail-title {
                font-size: 0.6rem;
                padding: 1px 2px;
            }

            /* Touch-friendly carousel */
            .carousel-container {
                touch-action: pan-y;
            }

            .carousel-slide {
                touch-action: pan-y;
            }
        }

        /* Floating WhatsApp */
        .floating-whatsapp {
            position: fixed;
            bottom: 25px;
            right: 25px;
            background: #25d366;
            color: white;
            width: 55px;
            height: 55px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            text-decoration: none;
            box-shadow: 0 4px 15px rgba(37, 211, 102, 0.4);
            animation: pulse 2s infinite;
            z-index: 1000;
        }

        @keyframes pulse {
            0% {
                box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
            }
            70% {
                box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
            }
            100% {
                box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
            }
        }

        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(30px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        /* Mobile-First Responsive Design */
        
        /* Mobile viewport height optimization */
        @media (max-width: 768px) {
            /* Force mobile sections to use 100vh for better UX */
            .hero,
            .summary,
            .gallery,
            .contact {
                min-height: 100vh !important;
            }
            
            /* Auto-adjust font sizes to fit viewport */
            .hero h1 {
                font-size: clamp(1.5rem, 6vw, 2.2rem);
                line-height: 1.2;
            }
            
            .hero p {
                font-size: clamp(0.9rem, 4vw, 1.1rem);
                padding: 0 15px;
                line-height: 1.4;
            }
            
            .summary h2,
            .section-title,
            .contact h2 {
                font-size: clamp(1.4rem, 5vw, 1.8rem);
            }
            
            .summary p,
            .section-subtitle,
            .gallery-subtitle,
            .contact p {
                font-size: clamp(0.85rem, 3.5vw, 1rem);
                line-height: 1.5;
            }
            
            /* Optimize content spacing for mobile */
            .hero-content,
            .summary-content,
            .contact-content {
                padding: 20px;
            }
            
            .container {
                padding: 0 15px;
            }
            
            /* Grid optimizations */
            .features-highlight {
                grid-template-columns: 1fr;
                gap: 1rem;
            }
            
            .gallery-grid {
                grid-template-columns: 1fr;
                gap: 1rem;
            }
            
            /* Floating WhatsApp optimization */
            .floating-whatsapp {
                width: 50px;
                height: 50px;
                bottom: 20px;
                right: 20px;
                font-size: 1.2rem;
            }
            
            /* Feature and gallery items mobile optimization */
            .feature-item {
                padding: 1rem;
            }
            
            .feature-item h3 {
                font-size: clamp(0.9rem, 3.5vw, 1rem);
            }
            
            .feature-item p {
                font-size: clamp(0.8rem, 3vw, 0.9rem);
            }
            
            .gallery-info h3 {
                font-size: clamp(0.95rem, 3.5vw, 1.1rem);
            }
            
            .gallery-info p {
                font-size: clamp(0.8rem, 3vw, 0.9rem);
            }
            
            /* Larger gallery images on mobile for better visibility */
            .gallery-image {
                height: 280px;
                font-size: 3.5rem;
            }
        }

        /* Small mobile devices - enhanced viewport optimization */
        @media (max-width: 480px) {
            .hero h1 {
                font-size: clamp(1.3rem, 7vw, 1.8rem);
            }
            
            .cta-button {
                padding: 14px 24px;
                font-size: clamp(0.9rem, 4vw, 1rem);
            }
            
            /* Ensure content doesn't overflow on very small screens */
            .hero,
            .summary,
            .gallery,
            .contact {
                min-height: 100dvh; /* Dynamic viewport height for better mobile support */
            }
        }
        
        /* Optimized Scrolling - Based on User Choice */
        html {
            scroll-behavior: smooth;
            scroll-padding-top: ${
              formData.headerFloating ? "60px" : "0px"
            }; /* Account for fixed header */
        }
        
        ${
          formData.scrollingType === "section"
            ? `
        /* Section Scroll - Desktop: Proximity scroll snap for smooth section navigation */
        @media (min-width: 769px) {
            html {
                scroll-snap-type: y proximity; /* Gentle guidance between sections */
            }
            
            .hero,
            .summary,
            .gallery {
                scroll-snap-align: start;
                scroll-snap-stop: normal; /* Allow smooth scrolling through */
            }
        }
        
        /* Section Scroll - Mobile: Mandatory scroll snap for precise section navigation */
        @media (max-width: 768px) {
            html {
                scroll-snap-type: y mandatory; /* Precise section-to-section navigation */
            }
            
            .hero,
            .summary,
            .gallery {
                scroll-snap-align: start;
                scroll-snap-stop: always; /* Ensure each section stops precisely */
                min-height: 100vh; /* Full viewport height for each section */
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: ${
                  formData.headerEnabled && formData.headerFloating
                    ? "60px"
                    : "0px"
                } !important;
                padding-bottom: 0px !important;
                box-sizing: border-box;
            }
            
            .hero {
                padding-top: ${
                  formData.headerEnabled && formData.headerFloating
                    ? "80px"
                    : "20px"
                } !important;
            }
            
            /* Smooth momentum scrolling for iOS */
            * {
                -webkit-overflow-scrolling: touch;
            }
        }
        `
            : `
        /* Smooth Scroll - Compact content with natural scrolling */
        .hero,
        .summary,
        .gallery {
            min-height: auto;
            padding: 2rem 0;
        }
        
        /* Compact mobile design for smooth scrolling */
        @media (max-width: 768px) {
            .hero {
                min-height: auto !important;
                padding: ${
                  formData.headerEnabled && formData.headerFloating
                    ? "100px 0 2rem 0"
                    : "2rem 0 1rem 0"
                } !important;
            }
            
            .summary,
            .gallery {
                min-height: auto !important;
                padding: 1.5rem 0 !important;
            }
            
            .container {
                padding: 0 1rem !important;
                max-width: 100% !important;
            }
            
            h1 {
                font-size: 1.75rem !important;
                line-height: 1.2 !important;
                margin-bottom: 0.75rem !important;
            }
            
            h2 {
                font-size: 1.5rem !important;
                margin-bottom: 0.5rem !important;
            }
            
            p {
                font-size: 0.9rem !important;
                line-height: 1.4 !important;
                margin-bottom: 0.75rem !important;
            }
            
            .features-highlight {
                gap: 1rem !important;
                margin: 1rem 0 !important;
                grid-template-columns: 1fr !important;
            }
            
            .feature-item {
                padding: 1rem !important;
            }
            
            .feature-item h3 {
                font-size: 1rem !important;
                margin-bottom: 0.25rem !important;
            }
            
            .feature-item p {
                font-size: 0.85rem !important;
            }
            
            .cta-button {
                padding: 0.75rem 1.5rem !important;
                font-size: 0.9rem !important;
            }
            
            .gallery-image {
                height: 200px !important;
                font-size: 3rem !important;
            }
            
            .gallery-info {
                padding: 1rem !important;
            }
        }
        `
        }
        
        /* Visual scroll indicators for mobile */
        @media (max-width: 768px) {
            /* Enhanced Mobile Section Styling */
            html {
                scroll-snap-type: y mandatory;
                scroll-behavior: smooth;
            }
            
            .mobile-scroll-container {
                scroll-snap-type: y mandatory;
                overflow-y: scroll;
                height: 100vh;
            }
            
            .mobile-section {
                scroll-snap-align: start;
                min-height: 100vh !important;
                height: 100vh !important;
                display: flex !important;
                flex-direction: column !important;
                justify-content: center !important;
                align-items: center !important;
                position: relative;
                padding-top: ${
                  formData.headerEnabled && formData.headerFloating
                    ? "60px"
                    : "0px"
                } !important;
                padding-bottom: 0px !important;
                box-sizing: border-box !important;
            }
            
            .mobile-section.hero {
                padding-top: ${
                  formData.headerEnabled && formData.headerFloating
                    ? "80px"
                    : "20px"
                } !important;
            }
            
            .mobile-section .container {
                height: 100% !important;
                display: flex !important;
                flex-direction: column !important;
                justify-content: center !important;
                align-items: center !important;
                padding: 20px !important;
                max-height: 100vh !important;
                overflow: visible !important;
            }
            
            .mobile-section .hero-content,
            .mobile-section .summary-content,
            .mobile-section .gallery-content {
                text-align: center !important;
                max-height: calc(100vh - ${
                  formData.headerEnabled && formData.headerFloating
                    ? "100px"
                    : "40px"
                }) !important;
                overflow: visible !important;
                display: flex !important;
                flex-direction: column !important;
                justify-content: center !important;
            }
        }
        
        @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
                transform: translateX(-50%) translateY(0);
            }
            40% {
                transform: translateX(-50%) translateY(-10px);
            }
            60% {
                transform: translateX(-50%) translateY(-5px);
            }
        }
    </style>
</head>
<body>
    ${
      formData.gtmEnabled && formData.gtmContainerId
        ? `
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${formData.gtmContainerId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
    `
        : ""
    }
    
    <!-- Main scroll container -->
    ${
      formData.scrollingType === "section"
        ? '<div class="mobile-scroll-container">'
        : "<div>"
    }
    
    ${
      formData.headerEnabled
        ? `
    <header>
        <nav class="container">
            <div class="logo">${formData.logoIcon} ${formData.websiteName}</div>
            <ul class="nav-links" style="display: none;">
                <li><a href="#contact">Kontak</a></li>
            </ul>
        </nav>
    </header>
    `
        : ""
    }

    <section id="home" class="hero ${
      formData.scrollingType === "section" ? "mobile-section" : ""
    }">
        <div class="container">
            <div class="hero-content">
                <h1>${formData.heroTitle}</h1>
                <p>${formData.heroSubtitle.replace(/\n/g, "<br>")}</p>
                <a href="https://wa.me/${
                  formData.whatsappNumber
                }?text=${encodeURIComponent(
      formData.whatsappText
    )}" class="cta-button">${formData.ctaText}</a>
            </div>
        </div>
    </section>

    <section id="summary" class="summary ${
      formData.scrollingType === "section" ? "mobile-section" : ""
    }">
        <div class="container">
            <div class="summary-content">
                <h2>${formData.summaryTitle}</h2>
                <p>${formData.summaryText1.replace(/\n/g, "<br>")}</p>
                <p>${formData.summaryText2.replace(/\n/g, "<br>")}</p>
                
                ${
                  formData.featuresCount > 0
                    ? `
                <div class="features-highlight features-${
                  formData.featuresCount
                }">
                    ${Array.from(
                      { length: formData.featuresCount },
                      (_, index) => {
                        const num = index + 1;
                        const title =
                          formData["feature" + num + "Title"] ||
                          "Feature " + num;
                        const desc =
                          formData["feature" + num + "Desc"] ||
                          "Deskripsi feature " + num;
                        return `
                        <div class="feature-item">
                            <h3>${title}</h3>
                            <p>${desc}</p>
                        </div>
                      `;
                      }
                    ).join("")}
                </div>
                `
                    : ""
                }
            </div>
        </div>
    </section>

    <section id="gallery" class="gallery ${
      formData.scrollingType === "section" ? "mobile-section" : ""
    }">
        <div class="container">
            <h2 class="section-title">${formData.galleryTitle}</h2>
            <p class="gallery-subtitle">${formData.gallerySubtitle.replace(
              /\n/g,
              "<br>"
            )}</p>
            
            <!-- Products Grid Layout -->
            <div class="products-container">
                ${Array.from(
                  { length: Math.min(formData.productsCount, 6) },
                  (_, productIndex) => {
                    const productNum = productIndex + 1;
                    const title =
                      formData["product" + productNum + "Title"] ||
                      "Produk " + productNum;
                    const description =
                      formData["product" + productNum + "Description"] ||
                      "Deskripsi produk " + productNum;

                    // Collect photos for this product with titles and descriptions
                    const photos = [];
                    for (let i = 1; i <= 6; i++) {
                      const photo =
                        formData["product" + productNum + "Photo" + i];
                      const photoTitle =
                        formData[
                          "product" + productNum + "Photo" + i + "Title"
                        ];
                      const photoDesc =
                        formData["product" + productNum + "Photo" + i + "Desc"];
                      if (photo) {
                        photos.push({
                          url: photo,
                          title: photoTitle || "", // Empty string if not filled
                          description: photoDesc || "", // Empty string if not filled
                        });
                      }
                    }

                    // If no photos, use emoji fallback
                    const emojis = ["📦", "⭐", "💰", "🎯", "👨‍👩‍👧‍👦", "💼"];
                    const emoji = emojis[productIndex % emojis.length];

                    return `
                    <div class="product-section" data-product="${productNum}">
                        <h3 class="product-title">${title}</h3>
                        <p class="product-description">${description.replace(
                          /\n/g,
                          "<br>"
                        )}</p>
                        
                        <div class="product-photos">
                            ${
                              photos.length > 0
                                ? `
                                <div class="product-carousel" id="carousel-${productNum}">
                                    <div class="carousel-container">
                                        <div class="carousel-track">
                                            ${photos
                                              .map(
                                                (photo, index) => `
                                                <div class="carousel-slide ${
                                                  index === 0 ? "active" : ""
                                                }" onclick="handleProductClick(event, '${title}')">
                                                    <img src="${
                                                      photo.url
                                                    }" alt="${
                                                  photo.title
                                                }" loading="lazy">
                                                </div>
                                            `
                                              )
                                              .join("")}
                                        </div>
                                        ${
                                          photos.length > 1
                                            ? `
                                            <button class="carousel-btn prev-btn" onclick="window.changeSlide(${productNum}, -1)" aria-label="Previous">
                                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"/>
                                                </svg>
                                            </button>
                                            <button class="carousel-btn next-btn" onclick="window.changeSlide(${productNum}, 1)" aria-label="Next">
                                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"/>
                                                </svg>
                                            </button>
                                            <div class="carousel-indicators">
                                                ${photos
                                                  .map(
                                                    (_, index) => `
                                                    <button class="indicator ${
                                                      index === 0
                                                        ? "active"
                                                        : ""
                                                    }" onclick="window.goToSlide(${productNum}, ${index})"></button>
                                                `
                                                  )
                                                  .join("")}
                                            </div>
                                        `
                                            : ""
                                        }
                                    </div>
                                    
                                    <!-- Photo Info Section -->
                                    <div class="photo-info" id="photo-info-${productNum}">
                                        ${photos
                                          .map(
                                            (photo, index) => `
                                            <div class="photo-details ${
                                              index === 0 ? "active" : ""
                                            }" data-slide="${index}">
                                                ${
                                                  photo.title
                                                    ? '<h4 class="photo-title">' +
                                                      photo.title +
                                                      "</h4>"
                                                    : ""
                                                }
                                                ${
                                                  photo.description
                                                    ? '<p class="photo-description">' +
                                                      photo.description +
                                                      "</p>"
                                                    : ""
                                                }
                                            </div>
                                        `
                                          )
                                          .join("")}
                                    </div>
                                </div>
                            `
                                : `
                                <div class="product-photo emoji-fallback" onclick="handleProductClick(event, '${title}')">
                                    <div class="emoji-display">${emoji}</div>
                                    <div class="photo-placeholder">Klik untuk info lebih lanjut</div>
                                </div>
                            `
                            }
                        </div>
                    </div>
                  `;
                  }
                ).join("")}
            </div>
        </div>
    </section>

    <a href="https://wa.me/${formData.whatsappNumber}?text=${encodeURIComponent(
      formData.whatsappText
    )}" class="floating-whatsapp" aria-label="Chat WhatsApp">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.106"/>
        </svg>
    </a>

    <script>
        // Optimized Smooth Scrolling - UX Best Practices
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const target = document.querySelector(this.getAttribute('href'));
                if (target) {
                    // Calculate offset for header if enabled and floating
                    const headerHeight = ${
                      formData.headerEnabled && formData.headerFloating
                        ? "(document.querySelector('header')?.offsetHeight || 60)"
                        : "0"
                    };
                    const targetPosition = target.offsetTop - headerHeight;
                    
                    // Use custom scrolling for better control
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        ${
          formData.gtmEnabled && formData.gtmContainerId
            ? `
        // GTM Event: CTA Button Clicks
        document.querySelectorAll('.cta, .cta-button, .hero .cta').forEach(button => {
            button.addEventListener('click', function() {
                dataLayer = dataLayer || [];
                dataLayer.push({
                    'event': 'cta_click',
                    'button_text': this.textContent,
                    'button_location': this.closest('section')?.id || 'unknown',
                    'page_title': '${formData.websiteName}',
                    'timestamp': new Date().toISOString()
                });
            });
        });

        // GTM Event: Scroll Depth Tracking
        let scrollDepthTracked = [];
        window.addEventListener('scroll', function() {
            const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
            const thresholds = [25, 50, 75, 100];
            
            thresholds.forEach(threshold => {
                if (scrollPercent >= threshold && !scrollDepthTracked.includes(threshold)) {
                    scrollDepthTracked.push(threshold);
                    dataLayer = dataLayer || [];
                    dataLayer.push({
                        'event': 'scroll_depth',
                        'scroll_percent': threshold,
                        'page_title': '${formData.websiteName}',
                        'timestamp': new Date().toISOString()
                    });
                }
            });
        });

        // GTM Event: Page Timer (time on page)
        let pageStartTime = new Date().getTime();
        let pageTimeTracked = [];
        setInterval(function() {
            const timeOnPage = Math.round((new Date().getTime() - pageStartTime) / 1000);
            const intervals = [30, 60, 120, 300]; // 30s, 1m, 2m, 5m
            
            intervals.forEach(interval => {
                if (timeOnPage >= interval && !pageTimeTracked.includes(interval)) {
                    pageTimeTracked.push(interval);
                    dataLayer = dataLayer || [];
                    dataLayer.push({
                        'event': 'page_timer',
                        'time_on_page': interval,
                        'page_title': '${formData.websiteName}',
                        'timestamp': new Date().toISOString()
                    });
                }
            });
        }, 5000); // Check every 5 seconds
        `
            : ""
        }

        window.addEventListener('scroll', function() {
            const header = document.querySelector('header');
            if (header && window.scrollY > 50) {
                // Simple rgba fallback instead of hex conversion
                header.style.background = 'rgba(56, 161, 105, 0.95)';
                header.style.backdropFilter = 'blur(10px)';
            } else if (header) {
                header.style.background = 'linear-gradient(135deg, ${
                  formData.primaryColor
                } 0%, ${formData.secondaryColor} 100%)';
                header.style.backdropFilter = 'none';
            }
        });

        // Helper function to convert hex to rgba
        function hexToRgba(hex, alpha) {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        }

        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -30px 0px'
        };

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.animation = 'fadeInUp 0.6s ease-out';
                }
            });
        }, observerOptions);

        document.querySelectorAll('.feature-item, .gallery-item').forEach(item => {
            observer.observe(item);
        });

        // Multi-Product Carousel Functionality
        (function() {
            // Store carousel states for each product
            const carouselStates = {};
            
            // Initialize all carousels
            function initializeCarousels() {
                const carousels = document.querySelectorAll('.product-carousel');
                carousels.forEach(function(carousel) {
                    const carouselId = carousel.id;
                    const productId = carouselId.replace('carousel-', '');
                    
                    const slides = carousel.querySelectorAll('.carousel-slide');
                    const indicators = carousel.querySelectorAll('.indicator');
                    const photoDetails = carousel.querySelectorAll('.photo-details');
                    
                    if (slides.length > 0) {
                        // Initialize state for this carousel
                        carouselStates[productId] = {
                            currentSlide: 0,
                            slides: slides,
                            indicators: indicators,
                            photoDetails: photoDetails,
                            totalSlides: slides.length,
                            autoplayInterval: null,
                            autoplaySpeed: 15000 // 15 seconds
                        };
                        
                        // Show first slide
                        showSlide(productId, 0);
                        
                        // Start autoplay if more than one slide
                        if (slides.length > 1) {
                            startAutoplay(productId);
                        }
                        
                        // Add hover pause functionality
                        carousel.addEventListener('mouseenter', function() {
                            stopAutoplay(productId);
                        });
                        
                        carousel.addEventListener('mouseleave', function() {
                            startAutoplay(productId);
                        });
                    }
                });
            }

            function showSlide(productId, slideIndex) {
                const state = carouselStates[productId];
                if (!state) return;
                
                // Remove active class from all slides and navigation
                state.slides.forEach(function(slide) {
                    slide.classList.remove('active');
                });
                
                state.indicators.forEach(function(indicator) {
                    indicator.classList.remove('active');
                });

                state.photoDetails.forEach(function(detail) {
                    detail.classList.remove('active');
                });

                // Show current slide and highlight active indicator
                if (state.slides[slideIndex]) {
                    state.slides[slideIndex].classList.add('active');
                }
                
                if (state.indicators[slideIndex]) {
                    state.indicators[slideIndex].classList.add('active');
                }

                if (state.photoDetails[slideIndex]) {
                    state.photoDetails[slideIndex].classList.add('active');
                }
                
                // Update current slide
                state.currentSlide = slideIndex;
            }

            function nextSlide(productId) {
                const state = carouselStates[productId];
                if (!state) return;
                
                const nextIndex = (state.currentSlide + 1) % state.totalSlides;
                showSlide(productId, nextIndex);
            }

            function prevSlide(productId) {
                const state = carouselStates[productId];
                if (!state) return;
                
                const prevIndex = (state.currentSlide - 1 + state.totalSlides) % state.totalSlides;
                showSlide(productId, prevIndex);
            }

            function startAutoplay(productId) {
                const state = carouselStates[productId];
                if (!state || state.totalSlides <= 1) return;
                
                // Clear existing interval
                if (state.autoplayInterval) {
                    clearInterval(state.autoplayInterval);
                }
                
                state.autoplayInterval = setInterval(function() {
                    nextSlide(productId);
                }, state.autoplaySpeed);
            }

            function stopAutoplay(productId) {
                const state = carouselStates[productId];
                if (!state || !state.autoplayInterval) return;
                
                clearInterval(state.autoplayInterval);
                state.autoplayInterval = null;
            }

            // Global functions for onclick handlers
            window.changeSlide = function(productId, direction) {
                if (direction === 1) {
                    nextSlide(productId);
                } else {
                    prevSlide(productId);
                }
            };

            window.goToSlide = function(productId, slideIndex) {
                showSlide(productId, slideIndex);
            };

            // Pause all carousels when page is not visible
            document.addEventListener('visibilitychange', function() {
                if (document.hidden) {
                    Object.keys(carouselStates).forEach(function(productId) {
                        stopAutoplay(productId);
                    });
                } else {
                    Object.keys(carouselStates).forEach(function(productId) {
                        const state = carouselStates[productId];
                        if (state && state.totalSlides > 1) {
                            startAutoplay(productId);
                        }
                    });
                }
            });

            // Initialize all carousels when DOM is ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initializeCarousels);
            } else {
                initializeCarousels();
            }
        })();

        // Gallery Click Handler - WhatsApp Integration
        function handleGalleryClick(event, itemTitle) {
            // Prevent carousel navigation when clicking on gallery items
            if (event && typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            
            // Use consistent WhatsApp message format across all buttons
            const baseMessage = "${formData.whatsappText}";
            const message = encodeURIComponent(baseMessage + " - Saya tertarik dengan " + itemTitle);
            const whatsappUrl = "https://wa.me/${
              formData.whatsappNumber
            }?text=" + message;
            
            // GTM tracking for gallery clicks
            ${
              formData.gtmEnabled && formData.gtmContainerId
                ? `
            dataLayer = dataLayer || [];
            dataLayer.push({
                'event': 'carousel_view',
                'gallery_item': itemTitle,
                'action': 'whatsapp_click',
                'page_title': '${formData.websiteName}',
                'timestamp': new Date().toISOString()
            });
            `
                : ""
            }
            
            // Redirect to WhatsApp in same tab (no blank tab left behind)
            window.location.href = whatsappUrl;
        }

        // Product Click Handler - WhatsApp Integration
        window.handleProductClick = function(event, productTitle) {
            // Prevent event bubbling
            if (event && typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            
            // Use consistent WhatsApp message format
            const baseMessage = "${formData.whatsappText}";
            const message = encodeURIComponent(baseMessage + " - Saya tertarik dengan " + productTitle);
            const whatsappUrl = "https://wa.me/${
              formData.whatsappNumber
            }?text=" + message;
            
            // GTM tracking for product clicks
            ${
              formData.gtmEnabled && formData.gtmContainerId
                ? `
            dataLayer = dataLayer || [];
            dataLayer.push({
                'event': 'product_click',
                'product_title': productTitle,
                'action': 'whatsapp_click',
                'page_title': '${formData.websiteName}',
                'timestamp': new Date().toISOString()
            });
            `
                : ""
            }
            
            // Redirect to WhatsApp in same tab
            window.location.href = whatsappUrl;
        }

        // Mobile Section Navigation & Progress Tracking
        let currentSection = 0;
        const sections = ['home', 'summary', 'gallery'];  // Updated section list
        
        // Section-based swipe navigation for mobile
        let startY = 0;
        let endY = 0;
        let isScrolling = false;
        
        if (window.innerWidth <= 768) {
            document.addEventListener('touchstart', e => {
                startY = e.touches[0].clientY;
                isScrolling = false;
            });
            
            document.addEventListener('touchmove', e => {
                isScrolling = true;
            });
            
            document.addEventListener('touchend', e => {
                if (!isScrolling) return;
                
                endY = e.changedTouches[0].clientY;
                const swipeThreshold = 50;
                const diff = startY - endY;
                
                if (Math.abs(diff) > swipeThreshold) {
                    if (diff > 0 && currentSection < sections.length - 1) {
                        // Swipe up - next section
                        currentSection++;
                        document.getElementById(sections[currentSection])?.scrollIntoView({ behavior: 'smooth' });
                    } else if (diff < 0 && currentSection > 0) {
                        // Swipe down - previous section
                        currentSection--;
                        document.getElementById(sections[currentSection])?.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            });
            
            // Track current section on scroll - only for mobile-section elements
            const sectionObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const sectionId = entry.target.id;
                        const newSection = sections.indexOf(sectionId);
                        if (newSection !== -1) {
                            currentSection = newSection;
                        }
                    }
                });
            }, { threshold: 0.5 });
            
            sections.forEach(sectionId => {
                const element = document.getElementById(sectionId);
                if (element) sectionObserver.observe(element);
            });
        }

    </script>
    
    </div> <!-- End mobile-scroll-container -->
    
</body>
</html>`;

    setGeneratedHTML(html);
    setShowPreview(true);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedHTML).then(() => {
      alert("HTML code copied to clipboard!");
    });
  };

  const downloadHTML = () => {
    const blob = new Blob([generatedHTML], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${formData.websiteName
      .toLowerCase()
      .replace(/\./g, "-")}-index.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="generator-container min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-custom-lg p-8 mb-8 border border-gray-200">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-800 mb-3">
              {/* Styling Aesthetic */}
              <span className="text-gradient bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-pink-500">
                JMBT
              </span>
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              - Conversion-Optimized Google Ads Landing Page Creator -
            </p>
            <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-lg max-w-3xl mx-auto">
              <p className="text-sm text-orange-800">
                ⚠️ <strong>Disclaimer:</strong> Designed for paid traffic
                (Google Ads), not organic SEO. Optimized for conversion, not
                search engine ranking.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            {/* Top Row - Tema Warna & Kontak (Compact) */}
            <div className="grid lg:grid-cols-3 gap-6">
              {/* Color Theme - Enhanced with Templates */}
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl border border-purple-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  🎨 <span className="ml-2">Warna Website</span>
                </h3>

                {/* Theme Templates */}
                <div className="mb-4">
                  <label className="block text-xs font-semibold text-gray-700 mb-2">
                    Template Warna
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    {Object.entries(colorThemes).map(([key, theme]) => (
                      <button
                        key={key}
                        type="button"
                        onClick={() => applyColorTheme(key)}
                        className={`p-2 rounded-lg border text-xs font-medium transition-all ${
                          formData.colorTheme === key
                            ? "border-blue-500 bg-blue-50 text-blue-700"
                            : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center space-x-1 mb-1">
                          <div
                            className="w-3 h-3 rounded-full"
                            style={{ backgroundColor: theme.primaryColor }}
                          ></div>
                          <div
                            className="w-3 h-3 rounded-full"
                            style={{ backgroundColor: theme.secondaryColor }}
                          ></div>
                          <div
                            className="w-3 h-3 rounded-full"
                            style={{ backgroundColor: theme.darkColor }}
                          ></div>
                        </div>
                        {theme.name}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Custom Color Controls */}
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Warna Utama
                    </label>
                    <div className="relative">
                      <input
                        type="color"
                        name="primaryColor"
                        value={formData.primaryColor}
                        onChange={(e) => {
                          handleInputChange(e);
                          setFormData((prev) => ({
                            ...prev,
                            colorTheme: "custom",
                          }));
                        }}
                        className="w-full h-10 border-2 border-gray-200 rounded-lg cursor-pointer"
                      />
                      <div className="absolute top-0 right-0 bg-white px-1 py-0.5 rounded-tr-lg rounded-bl-lg text-xs font-mono text-gray-600">
                        {formData.primaryColor}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Warna Kedua
                    </label>
                    <div className="relative">
                      <input
                        type="color"
                        name="secondaryColor"
                        value={formData.secondaryColor}
                        onChange={(e) => {
                          handleInputChange(e);
                          setFormData((prev) => ({
                            ...prev,
                            colorTheme: "custom",
                          }));
                        }}
                        className="w-full h-10 border-2 border-gray-200 rounded-lg cursor-pointer"
                      />
                      <div className="absolute top-0 right-0 bg-white px-1 py-0.5 rounded-tr-lg rounded-bl-lg text-xs font-mono text-gray-600">
                        {formData.secondaryColor}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Warna Aksen
                    </label>
                    <div className="relative">
                      <input
                        type="color"
                        name="darkColor"
                        value={formData.darkColor}
                        onChange={(e) => {
                          handleInputChange(e);
                          setFormData((prev) => ({
                            ...prev,
                            colorTheme: "custom",
                          }));
                        }}
                        className="w-full h-10 border-2 border-gray-200 rounded-lg cursor-pointer"
                      />
                      <div className="absolute top-0 right-0 bg-white px-1 py-0.5 rounded-tr-lg rounded-bl-lg text-xs font-mono text-gray-600">
                        {formData.darkColor}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* GTM Setup */}
              <div className="bg-gradient-to-r from-purple-50 to-violet-50 p-4 rounded-xl border border-purple-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  � <span className="ml-2">Google Tag Manager Setup</span>
                </h3>
                <div className="bg-purple-50 border border-purple-200 rounded-lg p-2 mb-3">
                  <p className="text-xs text-purple-800">
                    💡 <strong>Google Ads Tracking:</strong> GTM enables
                    conversion tracking, event monitoring, and analytics
                    integration
                  </p>
                </div>

                {/* GTM Enable Toggle */}
                <div className="flex items-center justify-between mb-3">
                  <label className="text-sm font-semibold text-gray-700">
                    Enable GTM Integration
                  </label>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        gtmEnabled: !prev.gtmEnabled,
                      }))
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      formData.gtmEnabled ? "bg-purple-600" : "bg-gray-200"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        formData.gtmEnabled ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>

                {formData.gtmEnabled && (
                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        GTM Container ID
                      </label>
                      <input
                        type="text"
                        name="gtmContainerId"
                        value={formData.gtmContainerId}
                        onChange={handleInputChange}
                        className="w-full p-2 text-sm border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:ring-1 focus:ring-purple-200 transition-all duration-200"
                        placeholder="GTM-XXXXXXX"
                      />
                    </div>

                    <div className="bg-green-50 border border-green-200 rounded-lg p-2">
                      <p className="text-xs text-green-800 mb-2">
                        <strong>📋 Pre-configured Events:</strong>
                      </p>
                      <ul className="text-xs text-green-700 space-y-1">
                        <li>
                          • <strong>whatsapp_form_submit</strong> - Contact form
                          WhatsApp submissions
                        </li>
                        <li>
                          • <strong>cta_click</strong> - Call-to-action button
                          clicks
                        </li>
                        <li>
                          • <strong>scroll_depth</strong> - 25%, 50%, 75%, 100%
                          page scroll
                        </li>
                        <li>
                          • <strong>carousel_view</strong> - Product carousel
                          interactions
                        </li>
                        <li>
                          • <strong>page_timer</strong> - Time spent on page
                          tracking
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* Website Info & WhatsApp Integration */}
              <div className="bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-xl border border-orange-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  📞{" "}
                  <span className="ml-2">
                    Website Info & WhatsApp Integration
                  </span>
                </h3>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-2 mb-3">
                  <p className="text-xs text-yellow-800">
                    💡 <strong>Info:</strong> WhatsApp akan muncul sebagai
                    floating button dan semua gallery item akan redirect ke
                    WhatsApp
                  </p>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      WhatsApp Number (dengan kode negara)
                    </label>
                    <input
                      type="text"
                      name="whatsappNumber"
                      value={formData.whatsappNumber}
                      onChange={handleInputChange}
                      className="w-full p-2 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="6281234567890"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Email (Optional)
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full p-2 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="info@mywebsite.com"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      WhatsApp Message (Base untuk semua button)
                    </label>
                    <textarea
                      name="whatsappText"
                      value={formData.whatsappText}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full p-2 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="Halo, saya tertarik dengan layanan Anda"
                    />
                  </div>
                </div>
              </div>

              {/* Row 2: Header & Navigation Settings + Info Website (50/50) */}
            </div>

            {/* Row 2: Header & Navigation Settings + Info Website (50/50) */}
            <div className="grid lg:grid-cols-2 gap-6">
              <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-4 rounded-xl border border-teal-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  ⚙️ <span className="ml-2">Header & Navigation Settings</span>
                </h3>
                <div className="bg-teal-50 border border-teal-200 rounded-lg p-2 mb-3">
                  <p className="text-xs text-teal-800">
                    💡 <strong>Kontrol Navigasi:</strong> Atur visibilitas
                    header dan pengaturan scroll untuk mengoptimalkan user
                    experience pada landing page
                  </p>
                </div>

                {/* Header Enable Toggle */}
                <div className="flex items-center justify-between mb-3">
                  <label className="text-sm font-semibold text-gray-700">
                    Show Header
                  </label>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        headerEnabled: !prev.headerEnabled,
                      }))
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      formData.headerEnabled ? "bg-teal-600" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        formData.headerEnabled
                          ? "translate-x-6"
                          : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>

                {/* Header Floating Toggle */}
                {formData.headerEnabled && (
                  <div className="flex items-center justify-between mb-3">
                    <label className="text-sm font-semibold text-gray-700">
                      Floating Header
                    </label>
                    <button
                      type="button"
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          headerFloating: !prev.headerFloating,
                        }))
                      }
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                        formData.headerFloating ? "bg-teal-600" : "bg-gray-300"
                      }`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                          formData.headerFloating
                            ? "translate-x-6"
                            : "translate-x-1"
                        }`}
                      />
                    </button>
                  </div>
                )}

                {/* Scrolling Type */}
                <div className="mb-3">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Scrolling Type
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      type="button"
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          scrollingType: "section",
                        }))
                      }
                      className={`p-2 rounded text-sm font-medium transition-all ${
                        formData.scrollingType === "section"
                          ? "bg-teal-500 text-white"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                    >
                      Section Scroll
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          scrollingType: "smooth",
                        }))
                      }
                      className={`p-2 rounded text-sm font-medium transition-all ${
                        formData.scrollingType === "smooth"
                          ? "bg-teal-500 text-white"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                    >
                      Smooth Scroll
                    </button>
                  </div>
                  <div className="bg-teal-50 border border-teal-200 rounded-lg p-2 mt-2">
                    <p className="text-xs text-teal-800">
                      💡 <strong>Section:</strong> Snap to sections
                      (mobile-friendly) | <strong>Smooth:</strong> Natural
                      scrolling with compact content
                    </p>
                  </div>
                </div>
              </div>

              {/* Info Website */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  📝 <span className="ml-2">Info Website</span>
                </h3>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
                  <p className="text-xs text-blue-800">
                    💡 <strong>Identitas Website:</strong> Informasi dasar
                    website seperti nama, jenis bisnis, dan logo untuk branding
                    yang konsisten
                  </p>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Nama Website
                    </label>
                    <input
                      type="text"
                      name="websiteName"
                      value={formData.websiteName}
                      onChange={handleInputChange}
                      className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="MyWebsite.com"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Jenis Bisnis
                    </label>
                    <input
                      type="text"
                      name="businessType"
                      value={formData.businessType}
                      onChange={handleInputChange}
                      className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="properti, kosan, dll"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Icon Logo
                    </label>
                    <input
                      type="text"
                      name="logoIcon"
                      value={formData.logoIcon}
                      onChange={handleInputChange}
                      className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="🏠"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Row 3: Main Form Grid - Bagian Utama & Kelebihan Manfaat */}
            <div className="grid lg:grid-cols-2 gap-6">
              {/* Left Column */}
              <div className="space-y-6">
                {/* Hero Content */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-5 rounded-xl border border-green-100">
                  <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                    🎯 <span className="ml-2">Bagian Utama (Header Awal)</span>
                  </h3>

                  {/* Height Control */}
                  <div className="mb-4 p-3 bg-white rounded-lg border border-gray-200">
                    <label className="block text-xs font-semibold text-gray-700 mb-2">
                      Section Height
                    </label>
                    <div className="grid grid-cols-3 gap-2 mb-2">
                      {heightOptions.map((option) => {
                        return (
                          <button
                            key={option.value}
                            type="button"
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                heroHeight: option.value,
                              }))
                            }
                            className={`p-2 rounded text-xs font-medium transition-all ${
                              formData.heroHeight === option.value
                                ? "bg-green-500 text-white"
                                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            }`}
                          >
                            {option.label}
                          </button>
                        );
                      })}
                    </div>
                    <div
                      className={`text-xs p-2 rounded ${
                        getHeightWarning(formData.heroHeight).type === "warning"
                          ? "bg-orange-50 text-orange-800"
                          : getHeightWarning(formData.heroHeight).type ===
                            "success"
                          ? "bg-green-50 text-green-800"
                          : "bg-blue-50 text-blue-800"
                      }`}
                    >
                      {getScrollIndicator(formData.heroHeight)} •{" "}
                      {getHeightWarning(formData.heroHeight).text}
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Judul Utama
                      </label>
                      <input
                        type="text"
                        name="heroTitle"
                        value={formData.heroTitle}
                        onChange={handleInputChange}
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Subtitle
                      </label>
                      <textarea
                        name="heroSubtitle"
                        value={formData.heroSubtitle}
                        onChange={handleInputChange}
                        rows="2"
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Teks Tombol
                      </label>
                      <input
                        type="text"
                        name="ctaText"
                        value={formData.ctaText}
                        onChange={handleInputChange}
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Advanced Options */}
              <div className="space-y-6">
                {/* Value Proposition Section */}
                <div className="bg-gradient-to-r from-cyan-50 to-blue-50 p-5 rounded-xl border border-cyan-100">
                  <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                    🎯{" "}
                    <span className="ml-2">
                      Kelebihan & Manfaat (Scrolling Kedua)
                    </span>
                  </h3>

                  {/* Height Control */}
                  <div className="mb-4 p-3 bg-white rounded-lg border border-gray-200">
                    <label className="block text-xs font-semibold text-gray-700 mb-2">
                      Section Height
                    </label>
                    <div className="grid grid-cols-3 gap-2 mb-2">
                      {heightOptions.map((option) => {
                        return (
                          <button
                            key={option.value}
                            type="button"
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                summaryHeight: option.value,
                              }))
                            }
                            className={`p-2 rounded text-xs font-medium transition-all ${
                              formData.summaryHeight === option.value
                                ? "bg-cyan-500 text-white"
                                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            }`}
                          >
                            {option.label}
                          </button>
                        );
                      })}
                    </div>
                    <div
                      className={`text-xs p-2 rounded ${
                        getHeightWarning(formData.summaryHeight).type ===
                        "warning"
                          ? "bg-orange-50 text-orange-800"
                          : getHeightWarning(formData.summaryHeight).type ===
                            "success"
                          ? "bg-green-50 text-green-800"
                          : "bg-blue-50 text-blue-800"
                      }`}
                    >
                      {getScrollIndicator(formData.summaryHeight)} •{" "}
                      {getHeightWarning(formData.summaryHeight).text}
                    </div>
                  </div>

                  <div className="bg-green-50 border border-green-200 rounded-lg p-2 mb-3">
                    <p className="text-xs text-green-800">
                      💡 <strong>Conversion Tip:</strong> Focus on the unique
                      value and benefits that differentiate you from competitors
                    </p>
                  </div>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Kelebihan Utama
                      </label>
                      <input
                        type="text"
                        name="summaryTitle"
                        value={formData.summaryTitle}
                        onChange={handleInputChange}
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                        placeholder="Why choose us over competitors?"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Manfaat #1
                      </label>
                      <textarea
                        name="summaryText1"
                        value={formData.summaryText1}
                        onChange={handleInputChange}
                        rows="2"
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                        placeholder="Primary benefit that solves customer pain point"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Manfaat #2
                      </label>
                      <textarea
                        name="summaryText2"
                        value={formData.summaryText2}
                        onChange={handleInputChange}
                        rows="2"
                        className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                        placeholder="Secondary benefit that adds value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Features Section - Full Width */}
            <div className="mt-6">
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-5 rounded-xl border border-yellow-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  ⭐{" "}
                  <span className="ml-2">
                    Keunggulan & Kepercayaan (Scrolling Kedua)
                  </span>
                </h3>

                {/* Features Count Control */}
                <div className="mb-4 p-3 bg-white rounded-lg border border-gray-200">
                  <label className="block text-xs font-semibold text-gray-700 mb-2">
                    Keunggulan & Kepercayaan (0-6) - Opsional
                  </label>
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
                    <p className="text-xs text-blue-800">
                      💡 <strong>Minimalist Option:</strong> Set to 0 for clean
                      value proposition only, or use 1-6 key benefits for trust
                      signals
                    </p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <input
                      type="range"
                      name="featuresCount"
                      min="0"
                      max="6"
                      value={Math.min(formData.featuresCount, 6)}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          featuresCount: parseInt(e.target.value),
                        }))
                      }
                      className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                    />
                    <div className="flex items-center space-x-2">
                      <button
                        type="button"
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            featuresCount: Math.max(
                              0,
                              Math.min(prev.featuresCount - 1, 6)
                            ),
                          }))
                        }
                        className="w-7 h-7 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors text-sm"
                      >
                        -
                      </button>
                      <span className="w-6 text-center font-bold text-gray-700">
                        {Math.min(formData.featuresCount, 6)}
                      </span>
                      <button
                        type="button"
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            featuresCount: Math.min(6, prev.featuresCount + 1),
                          }))
                        }
                        className="w-7 h-7 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors text-sm"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="mt-1 text-xs text-gray-500">
                    {formData.featuresCount === 0
                      ? "Clean minimalist design - Value proposition only"
                      : "Focus on key benefits that drive conversions"}
                  </div>
                </div>

                {/* Features Grid */}
                {formData.featuresCount === 0 ? (
                  <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 text-center">
                    <div className="text-gray-500 text-sm">
                      <p className="font-medium">✨ Minimalist Design Mode</p>
                      <p className="text-xs mt-1">
                        Landing page will show clean value proposition only -
                        perfect for focused messaging
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {Array.from(
                      { length: Math.min(formData.featuresCount, 6) },
                      (_, index) => {
                        const num = index + 1;
                        return (
                          <div
                            key={num}
                            className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm"
                          >
                            <div className="mb-2">
                              <input
                                type="text"
                                name={`feature${num}Title`}
                                value={formData[`feature${num}Title`] || ""}
                                onChange={handleInputChange}
                                className="w-full p-1.5 border border-gray-200 rounded text-sm font-medium"
                                placeholder={`Trust Signal ${num}`}
                              />
                            </div>
                            <textarea
                              name={`feature${num}Desc`}
                              value={formData[`feature${num}Desc`] || ""}
                              onChange={handleInputChange}
                              rows="2"
                              className="w-full p-1.5 border border-gray-200 rounded text-sm text-gray-600"
                              placeholder={`Key benefit that drives conversions ${num}`}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Produk (Scrolling Ketiga) - Full Width */}
            <div className="mt-6">
              <div className="bg-gradient-to-r from-pink-50 to-rose-50 p-5 rounded-xl border border-pink-100">
                <h3 className="font-bold text-lg mb-3 text-gray-800 flex items-center">
                  � <span className="ml-2">Produk (Scrolling Ketiga)</span>
                </h3>

                <div className="space-y-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Section Title
                    </label>
                    <input
                      type="text"
                      name="galleryTitle"
                      value={formData.galleryTitle}
                      onChange={handleInputChange}
                      className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="Our Products"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Section Description
                    </label>
                    <textarea
                      name="gallerySubtitle"
                      value={formData.gallerySubtitle}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full p-2.5 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                      placeholder="Brief description about your products offerings"
                    />
                  </div>

                  {/* Products Count Control */}
                  <div className="p-3 bg-white rounded-lg border border-gray-200">
                    <label className="block text-xs font-semibold text-gray-700 mb-2">
                      Jumlah Produk Section (1-6)
                    </label>
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
                      <p className="text-xs text-blue-800">
                        💡 <strong>Multiple Products:</strong> Buat 1-6 section
                        produk berbeda, masing-masing bisa punya beberapa foto
                      </p>
                    </div>
                    <div className="flex items-center space-x-4">
                      <input
                        type="range"
                        name="productsCount"
                        min="1"
                        max="6"
                        value={Math.min(formData.productsCount, 6)}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            productsCount: parseInt(e.target.value),
                          }))
                        }
                        className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                      />
                      <div className="flex items-center space-x-2">
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              productsCount: Math.max(
                                1,
                                Math.min(prev.productsCount - 1, 6)
                              ),
                            }))
                          }
                          className="w-7 h-7 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors text-sm"
                        >
                          -
                        </button>
                        <span className="w-6 text-center font-bold text-gray-700">
                          {Math.min(formData.productsCount, 6)}
                        </span>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              productsCount: Math.min(
                                6,
                                prev.productsCount + 1
                              ),
                            }))
                          }
                          className="w-7 h-7 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors text-sm"
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="mt-1 text-xs text-gray-500">
                      Tips: Setiap produk akan punya section terpisah dengan
                      foto-foto sendiri
                    </div>
                  </div>

                  {/* Products Configuration - Simple Format */}
                  <div className="space-y-6">
                    {Array.from(
                      { length: Math.min(formData.productsCount, 6) },
                      (_, productIndex) => {
                        const productNum = productIndex + 1;
                        return (
                          <div
                            key={productNum}
                            className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                          >
                            <h4 className="font-semibold text-lg text-gray-700 mb-4 flex items-center">
                              <span className="w-8 h-8 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                                {productNum}
                              </span>
                              Section Produk {productNum}
                            </h4>

                            {/* Product Title */}
                            <div className="mb-4">
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Judul Produk
                              </label>
                              <input
                                type="text"
                                name={`product${productNum}Title`}
                                value={
                                  formData[`product${productNum}Title`] ||
                                  `Produk ${productNum}`
                                }
                                onChange={handleInputChange}
                                className="w-full p-3 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
                                placeholder={`Nama Produk ${productNum}`}
                              />
                            </div>

                            {/* Product Description */}
                            <div className="mb-4">
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Deskripsi Produk
                              </label>
                              <textarea
                                name={`product${productNum}Description`}
                                value={
                                  formData[`product${productNum}Description`] ||
                                  ""
                                }
                                onChange={handleInputChange}
                                rows="3"
                                className="w-full p-3 text-sm border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
                                placeholder={`Deskripsi lengkap tentang produk ${productNum}`}
                              />
                            </div>

                            {/* Photos Section */}
                            <div className="mb-4">
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Upload Gambar Produk (Maksimal 6 foto)
                              </label>
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                {Array.from({ length: 6 }, (_, photoIndex) => {
                                  const photoNum = photoIndex + 1;
                                  const fieldName = `product${productNum}Photo${photoNum}`;
                                  const titleFieldName = `product${productNum}Photo${photoNum}Title`;
                                  const descFieldName = `product${productNum}Photo${photoNum}Desc`;
                                  return (
                                    <div
                                      key={photoNum}
                                      className="bg-gray-50 p-3 rounded-lg border border-gray-200"
                                    >
                                      <div className="text-sm font-medium text-gray-700 mb-2">
                                        Foto {photoNum}
                                      </div>

                                      {/* Image Preview */}
                                      {formData[fieldName] && (
                                        <div className="relative mb-3">
                                          <img
                                            src={formData[fieldName]}
                                            alt={`Preview ${productNum}-${photoNum}`}
                                            className="w-full h-32 object-cover rounded border border-gray-200"
                                          />
                                          <button
                                            type="button"
                                            onClick={() =>
                                              removeImage(fieldName)
                                            }
                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600 transition-colors"
                                            title="Hapus foto"
                                          >
                                            ×
                                          </button>
                                        </div>
                                      )}

                                      {/* File Upload */}
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                          handleImageUpload(e, fieldName)
                                        }
                                        className="w-full text-sm border border-gray-200 rounded p-2 mb-3 file:mr-2 file:py-1 file:px-3 file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                      />

                                      {/* Photo Title */}
                                      <input
                                        type="text"
                                        placeholder={`Judul foto ${photoNum}`}
                                        value={formData[titleFieldName] || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            [titleFieldName]: e.target.value,
                                          }))
                                        }
                                        className="w-full text-sm border border-gray-200 rounded p-2 mb-2 focus:outline-none focus:border-blue-500"
                                      />

                                      {/* Photo Description */}
                                      <textarea
                                        placeholder={`Deskripsi foto ${photoNum}`}
                                        value={formData[descFieldName] || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            [descFieldName]: e.target.value,
                                          }))
                                        }
                                        rows="2"
                                        className="w-full text-sm border border-gray-200 rounded p-2 resize-none focus:outline-none focus:border-blue-500"
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Generate Button */}
            <div className="mt-8 text-center">
              <button
                onClick={generateHTML}
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-10 py-4 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-blue-300"
              >
                🚀 Generate Landing Page
              </button>
            </div>
          </div>

          {/* Generated Output */}
          {showPreview && (
            <div className="bg-white rounded-xl shadow-custom-lg p-8 fade-in">
              <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
                <h2 className="text-3xl font-bold text-gray-800 flex items-center">
                  ✨ <span className="ml-2">Generated Landing Page</span>
                </h2>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={copyToClipboard}
                    className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
                  >
                    📋 Copy HTML
                  </button>
                  <button
                    onClick={downloadHTML}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
                  >
                    💾 Download HTML
                  </button>
                </div>
              </div>

              {/* Live Preview */}
              <div className="mb-8">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 gap-4">
                  <h3 className="text-xl font-bold text-gray-800 flex items-center">
                    👀 <span className="ml-2">Live Preview</span>
                  </h3>

                  {/* Device Preview Controls */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    {/* Orientation Toggle */}
                    {selectedDevice !== "desktop" && (
                      <button
                        onClick={() => setIsLandscape(!isLandscape)}
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                          isLandscape
                            ? "bg-purple-500 text-white"
                            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                        title="Toggle Landscape/Portrait"
                      >
                        {isLandscape ? "🔄 Landscape" : "📱 Portrait"}
                      </button>
                    )}

                    {/* Preview Info */}
                    <div className="px-3 py-2 bg-blue-50 text-blue-700 rounded-lg text-sm font-medium">
                      🔒 Fixed Height Preview (Better Performance)
                    </div>
                  </div>
                </div>

                {/* Device Selection Buttons */}
                <div className="mb-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">
                      📱️ Device Preview
                    </h4>

                    {/* Category Tabs */}
                    <div className="flex flex-wrap gap-2 mb-4">
                      <button
                        onClick={() => {
                          setDeviceCategory("mobile");
                          setSelectedDevice("iphone-15");
                        }}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          deviceCategory === "mobile"
                            ? "bg-blue-500 text-white shadow-md"
                            : "bg-white text-gray-700 hover:bg-blue-50 border border-gray-200"
                        }`}
                      >
                        📱 Mobile{" "}
                        <span className="ml-1 text-xs opacity-75">(8)</span>
                      </button>
                      <button
                        onClick={() => {
                          setDeviceCategory("tablet");
                          setSelectedDevice("ipad-10th");
                        }}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          deviceCategory === "tablet"
                            ? "bg-purple-500 text-white shadow-md"
                            : "bg-white text-gray-700 hover:bg-purple-50 border border-gray-200"
                        }`}
                      >
                        📱 Tablet{" "}
                        <span className="ml-1 text-xs opacity-75">(6)</span>
                      </button>
                      <button
                        onClick={() => {
                          setDeviceCategory("desktop");
                          setSelectedDevice("desktop");
                        }}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          deviceCategory === "desktop"
                            ? "bg-gray-500 text-white shadow-md"
                            : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
                        }`}
                      >
                        💻 Desktop
                      </button>
                    </div>

                    {/* Regional Presets */}
                    {deviceCategory !== "desktop" && (
                      <div className="mb-4">
                        <h5 className="text-xs font-semibold text-gray-600 mb-2">
                          Regional Presets
                        </h5>
                        <div className="flex flex-wrap gap-2">
                          {Object.entries(regionalPresets).map(
                            ([key, preset]) => (
                              <button
                                key={key}
                                onClick={() => setRegionalPreset(key)}
                                className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                                  regionalPreset === key
                                    ? "bg-orange-500 text-white shadow-md"
                                    : "bg-white text-gray-600 hover:bg-orange-50 border border-gray-200"
                                }`}
                                title={preset.description}
                              >
                                {preset.name}
                              </button>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {/* Desktop View */}
                    {deviceCategory === "desktop" && (
                      <div className="flex flex-wrap gap-2">
                        <button
                          onClick={() => setSelectedDevice("desktop")}
                          className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                            selectedDevice === "desktop"
                              ? "bg-gray-500 text-white shadow-md"
                              : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
                          }`}
                        >
                          💻 Desktop
                        </button>
                      </div>
                    )}

                    {/* Mobile Devices */}
                    {deviceCategory === "mobile" && (
                      <>
                        {/* iPhone Devices */}
                        <div className="mb-3">
                          <h5 className="text-xs font-semibold text-gray-600 mb-2">
                            iPhone Devices (Current Models)
                          </h5>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            {Object.entries(devicePresets)
                              .filter(
                                ([key, device]) =>
                                  device.category === "mobile" &&
                                  device.icon === "📱"
                              )
                              .map(([key, device]) => (
                                <button
                                  key={key}
                                  onClick={() => setSelectedDevice(key)}
                                  className={`px-3 py-2 rounded-lg text-xs font-medium transition-all text-left ${
                                    selectedDevice === key
                                      ? "bg-gray-800 text-white shadow-md"
                                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
                                  }`}
                                >
                                  {device.icon} {device.name}
                                  <div className="text-xs opacity-75 mt-1">
                                    {device.width}×{device.height} •{" "}
                                    {device.share}
                                  </div>
                                </button>
                              ))}
                          </div>
                        </div>

                        {/* Android Devices */}
                        <div>
                          <h5 className="text-xs font-semibold text-gray-600 mb-2">
                            Android Devices (2025 Updated)
                          </h5>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            {Object.entries(devicePresets)
                              .filter(
                                ([key, device]) =>
                                  device.category === "mobile" &&
                                  device.icon === "🤖"
                              )
                              .map(([key, device]) => (
                                <button
                                  key={key}
                                  onClick={() => setSelectedDevice(key)}
                                  className={`px-3 py-2 rounded-lg text-xs font-medium transition-all text-left ${
                                    selectedDevice === key
                                      ? "bg-green-500 text-white shadow-md"
                                      : "bg-white text-gray-700 hover:bg-green-50 border border-gray-200"
                                  }`}
                                >
                                  {device.icon} {device.name}
                                  <div className="text-xs opacity-75 mt-1">
                                    {device.width}×{device.height} •{" "}
                                    {device.share}
                                  </div>
                                </button>
                              ))}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Tablet Devices */}
                    {deviceCategory === "tablet" && (
                      <>
                        {/* iPad Devices */}
                        <div className="mb-3">
                          <h5 className="text-xs font-semibold text-gray-600 mb-2">
                            iPad Devices
                          </h5>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            {Object.entries(devicePresets)
                              .filter(
                                ([key, device]) =>
                                  device.category === "tablet" &&
                                  device.icon === "📱"
                              )
                              .map(([key, device]) => (
                                <button
                                  key={key}
                                  onClick={() => setSelectedDevice(key)}
                                  className={`px-3 py-2 rounded-lg text-xs font-medium transition-all text-left ${
                                    selectedDevice === key
                                      ? "bg-gray-800 text-white shadow-md"
                                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
                                  }`}
                                >
                                  {device.icon} {device.name}
                                  <div className="text-xs opacity-75 mt-1">
                                    {device.width}×{device.height} (Portrait)
                                  </div>
                                </button>
                              ))}
                          </div>
                        </div>

                        {/* Android Tablets */}
                        <div>
                          <h5 className="text-xs font-semibold text-gray-600 mb-2">
                            Android Tablets
                          </h5>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            {Object.entries(devicePresets)
                              .filter(
                                ([key, device]) =>
                                  device.category === "tablet" &&
                                  device.icon === "🤖"
                              )
                              .map(([key, device]) => (
                                <button
                                  key={key}
                                  onClick={() => setSelectedDevice(key)}
                                  className={`px-3 py-2 rounded-lg text-xs font-medium transition-all text-left ${
                                    selectedDevice === key
                                      ? "bg-green-500 text-white shadow-md"
                                      : "bg-white text-gray-700 hover:bg-green-50 border border-gray-200"
                                  }`}
                                >
                                  {device.icon} {device.name}
                                  <div className="text-xs opacity-75 mt-1">
                                    {device.width}×{device.height} (Portrait)
                                  </div>
                                </button>
                              ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Preview Container */}
                <div className="bg-gray-100 p-6 rounded-xl">
                  {/* Device Info */}
                  {selectedDevice !== "desktop" && (
                    <div className="text-center mb-4">
                      <span className="inline-block bg-white px-4 py-2 rounded-lg text-sm font-medium text-gray-700 shadow-sm border">
                        {devicePresets[selectedDevice].icon}{" "}
                        {devicePresets[selectedDevice].name}
                        {(() => {
                          const device = devicePresets[selectedDevice];
                          if (
                            isLandscape &&
                            device.widthLandscape &&
                            device.heightLandscape
                          ) {
                            return ` - ${device.widthLandscape}×${device.heightLandscape} (Landscape)`;
                          } else if (isLandscape) {
                            return ` - ${device.height}×${device.width} (Landscape)`;
                          } else {
                            return ` - ${device.width}×${device.height} (Portrait)`;
                          }
                        })()}
                        {devicePresets[selectedDevice].share && (
                          <span className="ml-2 text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                            {devicePresets[selectedDevice].share} market share
                          </span>
                        )}
                      </span>
                    </div>
                  )}

                  {/* Preview Frame */}
                  <div
                    id="device-preview"
                    className={`
                    ${
                      selectedDevice === "desktop"
                        ? "border-2 border-gray-200 rounded-xl overflow-hidden shadow-md bg-white"
                        : "mx-auto bg-gray-800 rounded-3xl p-2 shadow-2xl"
                    }
                    transition-all duration-300 ease-in-out
                  `}
                    style={
                      selectedDevice === "desktop" ? { height: "700px" } : {}
                    }
                  >
                    {selectedDevice !== "desktop" && (
                      <div className="bg-black rounded-2xl p-1">
                        <div
                          className="bg-white rounded-xl overflow-hidden shadow-inner"
                          style={getDeviceStyle()}
                        >
                          <iframe
                            srcDoc={generatedHTML}
                            className="w-full h-full"
                            title="Landing Page Preview"
                            style={{
                              border: "none",
                              scrollBehavior:
                                devicePresets[selectedDevice]?.category ===
                                "mobile"
                                  ? "smooth"
                                  : "auto",
                            }}
                          />
                        </div>
                      </div>
                    )}

                    {selectedDevice === "desktop" && (
                      <iframe
                        srcDoc={generatedHTML}
                        className="w-full h-full"
                        title="Landing Page Preview"
                        style={{
                          border: "none",
                          scrollBehavior: "auto",
                        }}
                      />
                    )}

                    {/* Keyboard Shortcuts Help */}
                    <div className="mt-4 text-xs text-gray-500 text-center">
                      <div className="bg-white p-2 rounded-lg shadow-sm border">
                        <strong>Keyboard Shortcuts:</strong> 1-9 (Quick device
                        selection) • R (Rotate) • F (Fullscreen)
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* HTML Code */}
              <div>
                <h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center">
                  📝 <span className="ml-2">HTML Code</span>
                </h3>
                <div className="bg-gray-900 text-green-400 p-6 rounded-xl overflow-auto max-h-96 text-sm font-mono border-2 border-gray-700">
                  <pre className="whitespace-pre-wrap">{generatedHTML}</pre>
                </div>
              </div>
            </div>
          )}

          {/* Instructions */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-8 mt-8">
            <h3 className="text-2xl font-bold text-blue-800 mb-6 flex items-center">
              📚 <span className="ml-2">Google Ads Landing Page Guide:</span>
            </h3>
            <ol className="list-decimal list-inside space-y-3 text-blue-700 text-lg leading-relaxed">
              <li>Focus on ONE clear value proposition in Hero section</li>
              <li>Keep max 3 trust signals and 3 products/services</li>
              <li>Use high-contrast colors that match your ad campaign</li>
              <li>Preview on mobile devices (most Google Ads traffic)</li>
              <li>Test different CTA button text for better conversion</li>
              <li>Deploy and connect to Google Ads for tracking</li>
            </ol>

            <div className="mt-6 p-4 bg-yellow-100 border border-yellow-300 rounded-lg">
              <p className="text-yellow-800 text-base">
                🎯 <strong>Conversion Tips:</strong> Use urgency words, clear
                benefits, and remove all distractions. This landing page is
                optimized for paid traffic conversion, not SEO ranking.
              </p>
            </div>

            <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-800 text-base">
                ⚠️ <strong>Important:</strong> This template includes
                noindex/nofollow meta tags. Designed specifically for Google Ads
                campaigns, not organic search traffic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageGenerator;
